<template>
    <div :class="{ 'center-screen' : !isMobile }">
        <div class="auth-page">
            <div class="container">
                <div class="form login">
                    <div class="flex direction-column justify-center align-center">
                        <svg style="width: 100px; height: 100px;" version="1.1" id="Icons" viewBox="0 0 32 32" xml:space="preserve"> <g> <path d="M31.5,8.9C30.7,7.2,29,6,27,6H15c-2,0-3.7,1.2-4.5,2.9L21,16.8L31.5,8.9z"/> <path d="M21.6,18.8C21.4,18.9,21.2,19,21,19s-0.4-0.1-0.6-0.2l-8.5-6.4L10,11l0,0c0,0,0,0,0,0H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h5   c0.6,0,1,0.4,1,1v0c0,0.6-0.4,1-1,1H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1,0.4,1,1v0c0,0.6-0.4,1-1,1H4c-0.6,0-1,0.4-1,1   s0.4,1,1,1h6c0,2.8,2.2,5,5,5h12c2.8,0,5-2.2,5-5V11c0,0,0,0,0,0L21.6,18.8z"/> </g> </svg>
                        <h2 style="margin-top: 0px;">Mail Gönderildi!</h2>
                        <small>Kayıtlı E-Mail adresinize giriş için doğrulama linki gönderildi. lütfen mailinize gelen linke tıklayıp giriş sağlayınız.</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  <script>
    export default{
      name: 'EmailPending',
      metaInfo () {
          return {
          title: 'Email Pending | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
          }
      },
      data(){
        return{
        }
      },
      mounted(){
      },
      methods:{
      },
    }
  </script>
  
  
  <style scoped lang="scss">
    h4{
      display: flex;
      align-items: center;
      svg{
        width: 30px;
        height: 30px;
      }
    }
    .auth-page{
        align-items: center;
        padding: 20px !important;
        .form{
            margin: 0 auto;
            padding: 20px !important;
            border-radius: 20px !important;
            text-align: center;
            svg{
                fill: var(--client-c3);
            }
        } 
    }
  </style>